export * as Themes from '../twentyDE/themes';
export * as Colors from '../twentyDE/colors';

import MessagesFr from './resources/messages.json';
import {Messages as MasterMessages} from '../master';

export const Messages = {...MasterMessages, ...MessagesFr};
